import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const RemoveIcon = ({ title = 'Info', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props}>
    <g fill="none">
      {/* prettier-ignore */}
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* prettier-ignore */}
      <path d="M10.7071 9.29289C10.3166 8.90237 9.68342 8.90237 9.29289 9.29289C8.90237 9.68342 8.90237 10.3166 9.29289 10.7071L10.7071 9.29289ZM13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L13.2929 14.7071ZM14.7071 10.7071C15.0976 10.3166 15.0976 9.68342 14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L14.7071 10.7071ZM9.29289 13.2929C8.90237 13.6834 8.90237 14.3166 9.29289 14.7071C9.68342 15.0976 10.3166 15.0976 10.7071 14.7071L9.29289 13.2929ZM9.29289 10.7071L13.2929 14.7071L14.7071 13.2929L10.7071 9.29289L9.29289 10.7071ZM13.2929 9.29289L9.29289 13.2929L10.7071 14.7071L14.7071 10.7071L13.2929 9.29289Z" fill="currentColor" />
    </g>
  </CreateIconComponent>
);

export default RemoveIcon;
